import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useFavoriteStore = create(
    persist(
      (set, get) => ({
        // Estado inicial
        favorites: [],
        favoriteStores: [],
  
         // Nuevo estado para el filtro de vista
      viewFilter: "all", // "all" o "favorites"

      // Nueva acción para cambiar el filtro de vista
      setViewFilter: (filter) => set({ viewFilter: filter }),

        // Acción para agregar una tienda favorita
        addFavorite: (store) =>
          set((state) => {
            // Verifica si la tienda ya existe para evitar duplicados
            const isExisting = state.favorites.some(
              (fav) => fav.maquina_id === store.maquina_id
            );
            if (isExisting) {
              return state; // No hagas nada si ya está en la lista
            }
            return {
              favorites: [...state.favorites, store],
            };
          }),
  
        // Acción para eliminar una tienda favorita
        removeFavorite: (storeId) =>
          set((state) => ({
            favorites: state.favorites.filter((fav) => fav.maquina_id !== storeId),
          })),
  
        // Acción para verificar si una máquina es favorita
        isFavoriteMachine: (storeId) => {
          return get().favorites.some((fav) => fav.maquina_id === storeId);
        },
  
        // Acción para obtener la lista completa de favoritos
        getFavorites: () => get().favorites,

        // Acción para agregar una tienda favorita
        addFavoriteStore: (store) =>
          set((state) => {
            // Verifica si la tienda ya existe para evitar duplicados
            const isExisting = state.favoriteStores.some(
              (fav) => fav.empresa_id === store.empresa_id
            );
            if (isExisting) {
              return state; // No hagas nada si ya está en la lista
            }
            return {
              favoriteStores: [...state.favoriteStores, store],
            };
          }),
  
        // Acción para eliminar una tienda favorita
        removeFavoriteStore: (storeId) =>
          set((state) => ({
            favoriteStores: state.favoriteStores.filter((fav) => fav.empresa_id !== storeId),
          })),
  
        // Acción para verificar si una tienda es favorita
        isFavorite: (storeId) => {
          return get().favoriteStores.some((fav) => fav.empresa_id === storeId);
        },
  
        // Acción para obtener la lista completa de favoritos
        getFavoriteStores: () => get().favoriteStores,
      }),
      
      {
        // Configuración del middleware de persistencia
        name: "favorite-stores", // Nombre para el localStorage
        storage: createJSONStorage(() => localStorage),
      }
    )
  );